import { render } from "./BaseSelectModal.vue?vue&type=template&id=65a51728"
import script from "./BaseSelectModal.vue?vue&type=script&lang=js"
export * from "./BaseSelectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__